export default {
  0: "随着企业发展，复杂的人员管理与用户在不同场景的访问行为会给公司的网络带来潜在的威胁。系统访问行为和员工账号状态能否被及时、有效监控，对公司业务安全有很大的影响。而且，无法记录登录信息、忽视身份信息管理的安全审计，还会威胁系统的安全，对于登录异常、非法授权访问等现象无法及时发现处理；无法掌握账号权限授予的过程，无法事故追责。同时，手动审计效率低且易出错。",
  1: "用户行为审计：记录用户每一次访问，包括时间、访问者、地点（IP地址，机器号），以及登录的应用，是否成功登录等。",
  2: "管理员行为审计：记录管理员账号权限分配操作。",
  3: "应用访问情况：帮助企业了解每一个应用的真实访问情况，有助于判断软件使用价值，优化 IT 投入成本。",
  4: "Authing  智能平台将会监测用户可疑登录行为或异常行为，并依据情况自动开启多因素认证，极大的提升了安全性。",
  5: "支持根据人员/部门自定义开启。",
  6: "Authing 支持自定义设定高强度的密码策略是否成功登录等。",
  7: "根据不同人员(组)设定不同的密码策略。",
  8: "作为企业级 SaaS 服务和关乎企业核心机密的身份服务提供商，Authing 始终把安全放在首位，Authing 有国际权威安全认证与成熟的信息安全管理体系，对软件全生命周期进行安全保障，拥有可靠的数据安全保护以及全天候安全应急响应措施。",
  9: "数据存储使用 AES-256 算法加密<br /> 数据通过 SSL/TLS 协议加密传输，2048 位 RSA 密钥<br /> 使用 KMS 管理密钥，密钥定期轮换，一次一密高安全保证<br /> 账户登录多因素身份认证<br /> 详细的数据访问与操作日志审计<br /> 客户端数据安全策略管理<br /> 数据高可用、多副本冗余存储与定时全量备份，<br /> 保证数据可用性、完整性与数据安全<br /> 全方位的安全防御",
  10: "被录入《中国网络安全产业白皮书》",
  11: " Authing 上线之初，就被中国信息通信研究院评选为“国内身份管理与访问控制领域创新企业”，并被录入《2019 年网络安全产业白皮书》。",
  // 12: "ISO/IEC 27001:2013 信息安全管理体系 ISO27001 是一套获得业界广泛认可的安全管理体系标准，其一直被认为是国际权威、严格的信息安全体系认证标准，被全球广泛接受。Authing 的数据中心、管理体系、研发、 职能部门通过此项认证意味着我们在信息安全管理领域已经与国际标准对标，具有充分的信息安全风险识别和控制能力，可以为全球客户提供安全可靠的服务。",
  // 13: "Authing 获得此项认证，是对我们长期以来在隐私合规体系建设方面工作的充分肯定，Authing 安全团队一直致力于保护用户隐私数据安全，为用户提供透明、高效、安全、可靠的服务。",
  12: "《通用数据保护条例》（General Data Protection Regulation，简称GDPR）为欧洲联盟的条例，前身是欧盟在1995年制定的《计算机数据保护法》。Authing 的数据中心、管理体系、研发、 职能部门通过此项认证意味着我们在信息安全管理领域已经与国际标准对标，具有充分的信息安全风险识别和控制能力，可以为全球客户提供安全可靠的服务。",
  13: "ISO 9001 质量保证体系是企业发展与成长之根本。Authing 获得此项认证，是对我们长期以来在隐私合规体系建设方面工作的充分肯定，Authing 安全团队一直致力于保护用户隐私数据安全，为用户提供透明、高效、安全、可靠的服务。",
  14: "公安部信息安全等级保护三级认证 《GB/T 22239-2008 信息安全技术信息系统安全等级保护基本要求》简称安全等级保护，是中国国家标准化管理委员会发布的信息安全标准，是中华人民共和国信息安全保障的一项基本制度。等级根据信息系统的重要程度，从低到高分为 1 至 5 个等级，不同安全等级实施不同的保护策略和要求。Authing 采用的是 3 级信息系统的保护策略，并顺利通过了专业测评机构的测评，标志着我们从在物理、网络、主机、应用、数据等方面，均具有被权威机构认可的安全防护能力，并且达到了行业内较高水平。",
  15: " 7x24 小时的安全应急响应 | 两地三中心备份，保证灾难时快速恢复 | 全方位保证提供持续稳定的服务",
  16: "Authing 统一身份认证平台风险点 - 原理是什么",
  "security-banner-subtitle":
    "Authing 遵从不同国家和行业的合规性要求，全力打造值得客户信赖的服务；同时，积极参与行业安全标准的制定及推广，坚持合规即服务，建设和运行安全可靠的云生态环境。",
  "security-strategy-item-1": "数据存储使用 AES-256 算法加密",
  "security-strategy-item-2": "数据通过 SSL/TLS 协议加密传输，2048 位 RSA 密钥",
  "security-strategy-item-3":
    "使用 KMS 管理密钥，密钥定期轮换，一次一密高安全保证",
  "security-strategy-item-4": "账户登录多因素身份认证",
  "security-strategy-item-5": "详细的数据访问与操作日志审计",
  "security-strategy-item-6": "客户端数据安全策略管理",
  "security-strategy-item-7": "数据高可用、多副本冗余存储与定时全量备份",
  "security-strategy-item-8": "保证数据可用性、完整性与数据安全",
  "security-strategy-item-9": "全方位的安全防御",
  Authing安全与合规: "Authing 安全与合规",
  安全防护策略: "安全防护策略",
  身份安全审计: "身份安全审计",
  密码管理: "密码管理",
  多因素安全认证策略: "多因素安全认证策略",
  合规性: "合规性",
  加密传输与存储: "加密传输与存储",
  ISO质量体系认证: "ISO 质量体系认证",
  GDPR通用数据保护条例: "GDPR 通用数据保护条例",
  三级等级保护: "三级等级保护",
  全生命周期安全保护: "全生命周期安全保护",
  员工A: "员工 A",
  重要应用访问异常时: "重要应用访问异常时",
  采取二次认证: "采取二次认证",
  员工B: "员工 B",
  仅异地出差时: "仅异地出差时",
  采取指纹认证: "采取指纹认证",
  员工C: "员工 C",
  访问行为十分稳定: "访问行为十分稳定",
  日常免密登录: "日常免密登录",
  总监: "总监",
  业务敏感内容比较多: "业务敏感内容比较多",
  强密加定期转轮: "强密加定期转轮",
  经理: "经理",
  少数业务系统: "少数业务系统",
  要求强密管理: "要求强密管理",
  实习生: "实习生",
  访问权限有限: "访问权限有限",
  弱密可满足基本需求: "弱密可满足基本需求",
  Authing解决方案: "Authing 解决方案",
  可视化安全审计: "可视化安全审计",
  多因素登录: "多因素登录",
  Authing合规: "Authing 合规",
  阅读报告: "阅读报告",
};
